import WBCONST from '../shared/constants/wb.const';
import buildColors from './colors';

let cachedColors = null;

export function getColors(themeColor) {
  if (themeColor) return buildColors(themeColor);
  if (!cachedColors) {
    const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('themeColor') : null;
    cachedColors = buildColors(stored || WBCONST.DEFAULT_THEME_COLOR);
  }
  return cachedColors;
}

export function invalidateColors() {
  cachedColors = null;
}
